import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';
import { IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';

@Component({
    selector: 'fi-checklist2-list-due-date',
    templateUrl: './fi-checklist2-list-due-date.component.html',
    styleUrls: ['./fi-checklist2-list-due-date.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-due-date' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListDueDateComponent }],
    standalone: false,
})
export class FiChecklist2ListDueDateComponent extends FiWrapperTableAdditionalColumns {
    @Input() headerLabelId: string = 'checklist.due_date';

    constructor(private fiChecklistHelperService: FiChecklistHelperService) {
        super();
    }

    isDueDateSoon(item: IChecklistV2ForList): boolean {
        return item.IsActive && this.fiChecklistHelperService.isTimeLessThenDay(item.DueDateTime);
    }

    getDueDateTimeText(item: IChecklistV2ForList): string {
        return this.fiChecklistHelperService.getDueDateTimeText(item, !!item.ScheduleId);
    }
}
